import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import { Box } from '@mui/material';
import { styled } from '@mui/styles';
import { useSelector } from 'react-redux';
import { RAPI_URL } from '../../circulusConfig';

const PlayerBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  jusstifyContent: 'center',
  alignItems: 'center',
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '1.5rem',
  transition: 'all 0.1s ease-in-out',
  fontSize: '1.5rem',
  color: theme.palette.secondary.main,
  flexShrink: 0,
  width: '1.5rem',
  height: '1.5rem',
  cursor: 'pointer',
}));

const MessagePlayer = ({ id, value, setPlayItem }) => {
  const { playItem } = useSelector((state) => state.messageBot);
  const [playData, setPlayData] = useState({
    playing: false,
    duration: 0,
    played: 0,
    src: null,
    url: null,
    className: '',
  });

  const handleClick = (e) => {
    e.stopPropagation();
    if (playData.playing) {
      setPlayItem(null);
    } else {
      setPlayItem({ id, value });
    }
  };

  const handleProgress = ({ playedSeconds, played }) => {
    if (played === 1) {
      setPlayItem(null);
      return setPlayData({
        ...playData,
        played: 0,
        url: null,
        playing: false,
      });
    }

    return setPlayData({
      ...playData,
      played: parseInt(Math.round(playedSeconds), 10),
    });
  };

  useEffect(() => {
    const [i, j] = playItem ? playItem.split('_') : [null, null];
    if (i === id && j === value) {
      setPlayData({
        ...playData,
        playing: true,
        url: `${RAPI_URL}message/${value}`,
      });
    } else {
      setPlayData({
        ...playData,
        played: 0,
        url: null,
        playing: false,
      });
    }
  }, [playItem]);

  return (
    <PlayerBox onClick={handleClick}>
      <ReactPlayer
        {...{
          played: playData.played,
          playing: playData.playing,
          url: playData.url,
          config: { file: { forceAudio: true } },
          width: 0,
          height: 0,
          volume: 1,
          onProgress: handleProgress,
        }}
      />
      {!playData.playing && <PlayArrowIcon />}
      {playData.playing && <StopIcon />}
    </PlayerBox>
  );
};

export default MessagePlayer;
